(function () {
  const LANDMARK_ID = 'BstShareThisLandmark';

  const NETWORK_LABELS = {
    facebook: 'Share on Facebook',
    twitter: 'Share on X',
    x: 'Share on X',
    pinterest: 'Pin on Pinterest',
    wechat: 'Share on WeChat',
    snapchat: 'Share on Snapchat',
    whatsapp: 'Share on WhatsApp',
    linkedin: 'Share on LinkedIn',
    email: 'Share by email',
  };

  function isShareThisOverlay(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.id && node.id.indexOf('st-el') === 0) return true;
    return node.classList.contains('st-image-share-buttons');
  }

  function enhanceButtons(root) {
    root.querySelectorAll('.st-btn').forEach(function (button) {
      if (!button.getAttribute('role')) {
        button.setAttribute('role', 'button');
      }

      if (!button.hasAttribute('tabindex')) {
        button.setAttribute('tabindex', '0');
      }

      if (!button.getAttribute('aria-label')) {
        const network = button.getAttribute('data-network');
        const label = NETWORK_LABELS[network] || (network ? 'Share on ' + network : 'Share');
        button.setAttribute('aria-label', label);
      }
    });
  }

  function containShareThis(node) {
    const landmark = document.getElementById(LANDMARK_ID);
    if (!landmark || !isShareThisOverlay(node) || landmark.contains(node)) return;

    landmark.appendChild(node);
    enhanceButtons(node);
  }

  function scanShareThis() {
    document.querySelectorAll('[id^="st-el"], .st-image-share-buttons').forEach(containShareThis);
  }

  function watchShareThis() {
    scanShareThis();

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!isShareThisOverlay(node)) return;
          containShareThis(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchShareThis);
  } else {
    watchShareThis();
  }
})();
